<template>
  <div class="block-faq__main">
    <h2 class="block-faq__title">{{ $t('faq.title') }}</h2>
    <div class="block-faq__list">
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Combien de temps prend le questionnaire ?</strong></p>
          <p>30 minutes environ.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Quelles sont les personnes les plus pertinentes dans l'entreprise pour répondre au questionnaire ?</strong></p>
          <p>Dirigeant, responsable informatique et directeur marketing, ou toute autre personne connaissant bien l'entreprise.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Comment les résultats sont-ils communiqués ?</strong></p>
          <p>Vous aurez accès à une interface dynamique d'analyse des données et vous pourrez enregistrer vos résultats
          sous forme d'un rapport pdf.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Quelle est la différence avec le DigiScan proposé par Agoria ?</strong></p>
          <p>Le DigiScan d'Agoria est orienté vers les entreprises B2B de plus de 10 personnes du secteur industriel. Le DigiScore de l'AdN s'adresse à toutes les entreprises wallonnes, sans distinction de taille ou de secteur.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Faut-il une préparation spécifique avant de répondre au questionnaire ?</strong></p>
          <p>Aucune préparation préalable n'est nécessaire.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Est-ce que je peux répondre au questionnaire en plusieurs fois ?</strong></p>
          <p>Oui, vous pouvez récupérer automatiquement toutes les données déjà encodées.</p>
        </div>
      </div>
      <div class="block-faq__list-item">
        <div class="block-faq-item">
          <p><strong>Comment sont calculés les scores des 4 axes spécifiques et le score global de maturité numérique ?</strong></p>
          <p>Le questionnaire comporte plus de 100 indicateurs auxquels sont attachés des scores qui permettent d'évaluer la présence
            et l'usage des technologies et des stratégies mises en oeuvre dans votre entreprise. La combinaison de ces scores, sur chaque
          axe de maturité, permet d'obtenir le DigiScore global.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
};
</script>
